import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { AnexoContratoResponse } from 'src/app/global/interfaces/anexo-contrato-response';
import { AnexoContratoService } from 'src/app/global/services/anexo-contrato.service';
import { environment } from 'src/environments/environment';


@Injectable()
export class AnexoContratoProvider extends AnexoContratoService {

    private baseUrl = _.get(environment, 'api.host', '');
    private basePath = _.get(environment, 'api.path', '');
    private baseEndpoint = _.get(environment, 'api.endpoints');
    private endpoint: string;

    constructor(private http: HttpClient) {
        super();
    }

    getAnexoContrato(): Observable<any> {

        this.endpoint = this.baseUrl + this.basePath + _.get(this.baseEndpoint, 'PASO_3.ANEXO_CONTRATO');
        return this.http.get(this.endpoint);
    }

    getEstadoAnexos(): Observable<AnexoContratoResponse> {
        this.endpoint = this.baseUrl + this.basePath + _.get(this.baseEndpoint, 'PASO_3.ANEXO_CONTRATO') + _.get(this.baseEndpoint, 'PASO_3.ESTADO_ANEXOS');
        return this.http.get<AnexoContratoResponse>(this.endpoint);
    }

    postApruebaDocumento(data): Observable<any> {
        this.endpoint = this.baseUrl + this.basePath + _.get(this.baseEndpoint, 'PASO_3.ANEXO_CONTRATO') + _.get(this.baseEndpoint, 'PASO_3.APRUEBA_DOCUMENTO');
        // this.endpoint = 'http://localhost:3001/bff-checkout/api/checkout/anexo-contrato/aprueba-documento';
        return this.http.post(this.endpoint, data);
    }

    postAprobarAnexoContratoComercio(): Observable<any> {
        this.endpoint = this.baseUrl + this.basePath + _.get(this.baseEndpoint, 'PASO_3.ANEXO_CONTRATO') + _.get(this.baseEndpoint, 'PASO_3.APRUEBA_ANEXO_COMERCIO');
        return this.http.post(this.endpoint, {});
    }

    postAprobarAnexoContratoRepresentante(): Observable<any> {
        this.endpoint = this.baseUrl + this.basePath + _.get(this.baseEndpoint, 'PASO_3.ANEXO_CONTRATO') + _.get(this.baseEndpoint, 'PASO_3.APRUEBA_ANEXO_REPRESENTANTE');
        return this.http.post(this.endpoint, {});

    }

    getTipoAprobacion(): Observable<any> {

        this.endpoint = this.baseUrl + this.basePath + _.get(this.baseEndpoint, 'PASO_3.ANEXO_CONTRATO') + _.get(this.baseEndpoint, 'PASO_3.TIPO_APROBACION');
        return this.http.get(this.endpoint);
    }

    getPreviewDocumento(): Observable<any> {
        this.endpoint = this.baseUrl + this.basePath + _.get(this.baseEndpoint, 'PASO_3.PREVIEW_CONTRATO');
        return this.http.get(this.endpoint);
    }
}
